import { render } from "./TutorialStep.vue?vue&type=template&id=56faa67a&scoped=true&ts=true"
import script from "./TutorialStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./TutorialStep.vue?vue&type=script&setup=true&lang=ts"

import "./TutorialStep.vue?vue&type=style&index=0&id=56faa67a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56faa67a"],['__file',"src/components/TutorialStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56faa67a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56faa67a', __exports__)) {
    api.reload('56faa67a', __exports__)
  }
  
  module.hot.accept("./TutorialStep.vue?vue&type=template&id=56faa67a&scoped=true&ts=true", () => {
    api.rerender('56faa67a', render)
  })

}


export default __exports__